export default "/_next/static/images/6c00f8b0877c4136300ec6942df1671e.png";